import { CardValidatorOrdered } from '../core/card/CardValidatorOrdered.ts';
export class MechanicValidatorDevelopmentCardPlayer {
    get developmentCardsBoughtThisTurn() {
        var _this_developmentCardPlayerState_developmentCardsBoughtThisTurn;
        return (_this_developmentCardPlayerState_developmentCardsBoughtThisTurn = this.developmentCardPlayerState.developmentCardsBoughtThisTurn) !== null && _this_developmentCardPlayerState_developmentCardsBoughtThisTurn !== void 0 ? _this_developmentCardPlayerState_developmentCardsBoughtThisTurn : [];
    }
    get developmentCardsUsed() {
        return this.developmentCardPlayerState.developmentCardsUsed;
    }
    get hasUsedDevelopmentCardThisTurn() {
        return this.developmentCardPlayerState.hasUsedDevelopmentCardThisTurn;
    }
    constructor(developmentCardPlayerState){
        this.developmentCardPlayerState = developmentCardPlayerState;
        this.developmentCards = new CardValidatorOrdered(this.developmentCardPlayerState.developmentCards);
    }
}
